import React from 'react'

import NumberField from '../../../core/components/NumberField'
import { Element } from '../../lib/Element'
import { Answer } from '../../lib/types'

interface NumberElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
}

/**
 * Editor component for TextElement
 */
export const NumberElementQuestion: React.FC<NumberElementQuestionProps> = ({
  element,
  onChange,
}) => {
  const [value, setValue] = React.useState<number | null>(null) //TODO get current value

  const handleOnChange = (value: number | null) => {
    setValue(value)
    onChange?.({ answer: String(value) })
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      const min = element.getParam<number>('min')
      const max = element.getParam<number>('max')
      if (min && value !== null && value < min) {
        return ' Value cannot be less than ' + min // TODO Translate
      }
      if (max && value !== null && value > max) {
        return ' Value cannot be more than ' + max // TODO Translate
      }
      if (element.mandatory && value === null) {
        return 'This field is required' // TODO Translate
      }
    }
    return undefined
  }

  return (
    <NumberField
      hideLabel
      label={element.label}
      mandatory={element.mandatory}
      placeholder={'Add your answer'} // TODO: Translate
      value={value}
      onChange={handleOnChange}
      // readonly={!onChange}
      error={getError()}
      min={element.getParam<number>('min')}
      max={element.getParam<number>('max')}
    />
  )
}
